import { Stack, Title } from "@mantine/core"

import { FindOperationChainItemsResponseDto } from "~/gen/api/types"

import { OpChainDragDrop } from "./OpChainDragDrop/OpChainDragDrop"
import { OpChainItemCreation } from "./OpChainItemCreation"

interface OpChainContentProps {
  activityItems: FindOperationChainItemsResponseDto[]
  operationChainId: string
}

export function OpChainContent({
  activityItems,
  operationChainId,
}: OpChainContentProps) {
  return (
    <Stack>
      <Title order={1}>OpChain Management</Title>
      <OpChainItemCreation />
      <Title order={3}>Activities</Title>
      <OpChainDragDrop
        activityItems={activityItems}
        operationChainId={operationChainId}
      />
    </Stack>
  )
}
